export default "__VITE_ASSET__BQhYVVlO__"